import io from 'socket.io-client';
import { CustomAppLayout } from '../layout';
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useRouter } from '../router';
//import { useStore } from '../store';
import { useGlobalState } from '../../context/GlobalStateContext';




import { Alert, Button, Container, Divider, ExpandableSection, FlashbarProps, Form, FormField, KeyValuePairs, Link, SegmentedControl, SpaceBetween, StatusIndicator, Tabs } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiArrowCollapseVertical, mdiCctv, mdiCheckboxMultipleBlankOutline, mdiThermometer, mdiWeatherSunsetDown, mdiWeatherWindy } from '@mdi/js';
import Icon from '@mdi/react';
//import CompassGauge from '../../../components/charts/RadialGauge';
import { tz } from '@date-fns/tz';
import { format } from 'date-fns';
import GaugePressure from '../../../components/charts/GaugePresure';
import GaugeTemp from '../../../components/charts/GaugeTemp';
import GaugeWind from '../../../components/charts/GaugeWind';
import PopOverContact from '../../../components/extras/PopOverContact';
import Spacer from '../../../components/extras/Spacer';
import StepsCheck from '../../../components/extras/StepsCheck';
import { fetchWithWatch } from '../../../hooks/fetchWithWatch';
import { ItemCheck, ItemsGroups, ItemsMovement, ItemUser } from '../../../resources/types';
import { addNotification, buildBreadcrumbItems, formatCurrency, getBankSvg, getCookie, getUrlVersion, isMobileDevice, setData, setLoading, storeJWT } from '../../commons/functions';
import { HomePage } from './home';



export const HomeTabs = ({ tabs = [], initialActiveTabId = "home" }) => {
    const { idUser, data, menu } = useGlobalState();
    const [activeTabId, setActiveTabId] = useState(initialActiveTabId);
    console.log(activeTabId)
    //const storeAdmin = useStoreAdmin();


    const { navigate } = useRouter();


    const targetRef = useRef<HTMLDivElement>(null);
    const [vpWidth, setVpWidth] = useState(0);


    return (
        <CustomAppLayout
            toolsHide={true}
            breadcrumbs={
                <BreadcrumbGroup
                    items={buildBreadcrumbItems(menu)}
                    expandAriaLabel="Show path"
                    ariaLabel="Breadcrumbs"
                />
            }
            disableContentPaddings
            content={
                <div ref={targetRef}>
                    <Tabs
                        activeTabId={activeTabId}
                        onChange={({ detail }) => {
                            setActiveTabId(detail.activeTabId);
                        }}
                        disableContentPaddings={false}
                        tabs={[
                            {
                                id: "home",
                                label: "Inicio",
                                content: <HomePage />,
                                dismissible: false,
                            },
                            ...tabs
                        ]}
                    />
                </div>
            }

        />
    );
};
